import { render, staticRenderFns } from "./entpDatas.vue?vue&type=template&id=64208346&scoped=true&"
import script from "./entpDatas.vue?vue&type=script&lang=js&"
export * from "./entpDatas.vue?vue&type=script&lang=js&"
import style0 from "./entpDatas.vue?vue&type=style&index=0&id=64208346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64208346",
  null
  
)

component.options.__file = "entpDatas.vue"
export default component.exports